import { render, staticRenderFns } from "./MarketplaceRegistrationForm.vue?vue&type=template&id=08f4ba09&"
import script from "./MarketplaceRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports